import React, { useState } from 'react';

const ContactSlideout = ({ isOpen, onClose, couple }) => {
  const [formData, setFormData] = useState({
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
         // ✅ Leer email del localStorage
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    const userEmail = storedUser.email || 'email@ejemplo.com';
    const response = await fetch('https://gift-contactsendemail-336444799661.us-central1.run.app/contactSendEmail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: `${couple.brideName} & ${couple.groomName}`,
        email: userEmail, // ✅ Email del localStorage
          subject: formData.subject,
          message: formData.message
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('✅ Mensaje enviado. Te responderemos a ' + couple.email + ' en menos de 24 horas.');
        setFormData({ subject: '', message: '' });
        onClose();
      } else {
        alert('❌ Error al enviar el mensaje');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('❌ Error al enviar el mensaje');
    } finally {
      setLoading(false);
    }
  };

  const quickMessages = [
    {
      icon: '💬',
      label: 'No veo los regalos recibidos',
      subject: 'Problema técnico',
      message: 'No puedo ver los regalos recibidos en mi dashboard.'
    },
    {
      icon: '💳',
      label: '¿Cómo hacen el pago los invitados?',
      subject: 'Consulta sobre pagos',
      message: 'Un invitado me pregunta cómo hacer el pago.'
    },
    {
      icon: '📅',
      label: 'Cambiar fecha del evento',
      subject: 'Modificar mi lista',
      message: 'Necesito cambiar la fecha de mi evento.'
    }
  ];

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl transform transition-transform duration-300 animate-slide-left"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-neutral-200 px-6 py-5 flex items-center justify-between">
          <h2 className="text-xl font-display font-bold text-neutral-900">
            Contactar Soporte
          </h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-neutral-200 flex items-center justify-center transition-colors"
            aria-label="Cerrar"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6 overflow-y-auto h-[calc(100vh-80px)]">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800">
              💡 <strong>Respondemos rápido:</strong> Te contestaremos a{' '}
              <span className="font-semibold">{couple.email}</span> en menos de 24 horas.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-neutral-700 mb-2">
                Asunto *
              </label>
              <select
                value={formData.subject}
                onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                required
                className="input-field"
              >
                <option value="">Seleccioná un tema</option>
                <option value="Problema técnico">Problema técnico</option>
                <option value="Consulta sobre pagos">Consulta sobre pagos</option>
                <option value="Modificar mi lista">Modificar mi lista</option>
                <option value="Cancelar cuenta">Cancelar cuenta</option>
                <option value="Otro">Otro</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-neutral-700 mb-2">
                Mensaje *
              </label>
              <textarea
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                required
                rows="10"
                className="input-field resize-none"
                placeholder="Contanos en qué podemos ayudarte..."
                maxLength="1000"
              />
              <p className="text-xs text-neutral-400 text-right mt-1">
                {formData.message.length}/1000
              </p>
            </div>

            {/* Shortcuts de ayuda rápida */}
            <div className="border-t border-neutral-200 pt-5">
              <p className="text-sm font-medium text-neutral-700 mb-3">
                ¿Necesitás ayuda rápida?
              </p>
              <div className="space-y-2">
                {quickMessages.map((quick, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => setFormData({
                      subject: quick.subject,
                      message: quick.message
                    })}
                    className="w-full text-left px-4 py-3 bg-neutral-50 hover:bg-neutral-100 rounded-lg text-sm transition-colors flex items-center gap-3"
                  >
                    <span className="text-xl">{quick.icon}</span>
                    <span>{quick.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full btn-primary text-lg py-4 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Enviando...' : 'Enviar Mensaje'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactSlideout;